export const GAP_BETWEEN_ITEMS = 24;
export const GAP_BETWEEN_ITEMS_MOBILE = 16;
export const CAROUSEL_DEFAULT_CONFIG = {
    sm: {
        width: '242px',
        height: '136px',
    },
    md: {
        width: '255px',
        height: '144px',
    },
    lg: {
        width: '546px',
        height: '308px',
    },
};
